import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "c-picture--default lazyload",
    "data-css": "c-picture"
};
const _hoisted_2 = ["src", "alt", "title"];
import { computed } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'NewsListItemImagePicture',
    props: {
        image: {}
    },
    setup(__props) {
        const { image } = __props;
        const srcSet = computed(() => image?.content.items[0].srcset);
        const sizes = computed(() => {
            const s = image?.content.items[0].sizes ?? "";
            const d = s?.split(',').filter(Boolean);
            const index = d.length - 1;
            const size = d[index] ?? "";
            return size;
        });
        return (_ctx, _cache) => {
            const _directive_set_attr = _resolveDirective("set-attr");
            return (_ctx.image)
                ? (_openBlock(), _createElementBlock("picture", _hoisted_1, [
                    _createCommentVNode("[if IE 9]><audio><![endif]"),
                    _withDirectives(_createElementVNode("source", null, null, 512 /* NEED_PATCH */), [
                        [_directive_set_attr, { 'data-srcset': srcSet.value, 'sizes': sizes.value, 'srcset': srcSet.value }]
                    ]),
                    _createCommentVNode("[if IE 9]></audio><![endif]"),
                    _withDirectives(_createElementVNode("img", {
                        class: "picture__image lazyload",
                        src: _ctx.image?.content.fallbackSrc,
                        alt: _ctx.image?.content?.alt,
                        title: _ctx.image?.content.title
                    }, null, 8 /* PROPS */, _hoisted_2), [
                        [_directive_set_attr, { 'data-sizes': 'auto', 'sizes': sizes.value }]
                    ])
                ]))
                : _renderSlot(_ctx.$slots, "default", { key: 1 });
        };
    }
});
